import { useInfiniteQuery } from "@tanstack/react-query";
import searchPoliceProfiles from "../axios/searchPoliceProfiles";

const useQuerySearchPoliceProfiles = (searchTerm: string) => {
  return useInfiniteQuery(
    ["search_kepolisian_internasional", searchTerm],
    ({ pageParam = 1 }) => {
      return searchPoliceProfiles({ search: searchTerm, page: pageParam });
    },
    {
      enabled: Boolean(searchTerm.trim()),
      getNextPageParam: (lastPage, allPages) => {
        const policeProfilesList = allPages.flatMap(
          (page) => page.kepolisian_internasional.data,
        );
        if (
          policeProfilesList.length < lastPage.kepolisian_internasional.total
        ) {
          return lastPage.kepolisian_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );
};

export default useQuerySearchPoliceProfiles;
